import { render, staticRenderFns } from "./NavigationInfo.vue?vue&type=template&id=5b6482f5&scoped=true&"
import script from "./NavigationInfo.vue?vue&type=script&lang=js&"
export * from "./NavigationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6482f5",
  null
  
)

export default component.exports